var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMySubscriptions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.489,
    height: 82.994,
    viewBox: "0 0 82.489 82.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "my_subscriptions",
    transform: "translate(-69.548 -65.706)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8462",
    "data-name": "Path 8462",
    d: "M315.345,104.019a11.56,11.56,0,0,1,11.547,11.547,1.876,1.876,0,1,0,3.752,0,15.317,15.317,0,0,0-15.3-15.3,1.876,1.876,0,1,0,0,3.752Z",
    transform: "translate(-186.715 -26.456)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8463",
    "data-name": "Path 8463",
    d: "M315.345,65.706a1.876,1.876,0,1,0,0,3.752A19.675,19.675,0,0,1,335,89.11a1.876,1.876,0,1,0,3.752,0,23.431,23.431,0,0,0-23.407-23.4Z",
    transform: "translate(-186.715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8464",
    "data-name": "Path 8464",
    d: "M119.409,325.235a11.56,11.56,0,0,1-11.547-11.547,1.876,1.876,0,1,0-3.752,0,15.317,15.317,0,0,0,15.3,15.3,1.876,1.876,0,0,0,0-3.752Z",
    transform: "translate(-26.456 -188.387)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8465",
    "data-name": "Path 8465",
    d: "M92.953,333.341A19.675,19.675,0,0,1,73.3,313.688a1.876,1.876,0,0,0-3.752,0,23.431,23.431,0,0,0,23.4,23.4,1.876,1.876,0,1,0,0-3.752Z",
    transform: "translate(0 -188.388)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8466",
    "data-name": "Path 8466",
    d: "M189.723,131.725A30.654,30.654,0,0,1,167.2,120.79l-2.663-3.176a20.784,20.784,0,0,0-27.168-6.162,6.749,6.749,0,1,0-7.919,7.919,20.784,20.784,0,0,0,6.162,27.168l3.176,2.663a30.654,30.654,0,0,1,10.934,22.521,1.876,1.876,0,0,0,3.2,1.269l10.9-10.9a11.678,11.678,0,0,0,16.264-16.264l10.9-10.9a1.876,1.876,0,0,0-1.269-3.2Zm-61.09-16.855a3,3,0,1,1,4.237,0A3,3,0,0,1,128.633,114.87ZM141.2,146.326l-3.238-2.715q-.064-.053-.132-.1a17.007,17.007,0,1,1,23.679-23.679q.047.068.1.132l2.715,3.238a34.335,34.335,0,0,0,7.779,6.842l-24.062,24.062a34.336,34.336,0,0,0-6.842-7.779Zm37.248,6.2a7.931,7.931,0,0,1-11.911,6.858l10.84-10.84a7.872,7.872,0,0,1,1.071,3.982ZM153.1,167.509a34.406,34.406,0,0,0-3.145-10.011l25.54-25.541a34.407,34.407,0,0,0,10.011,3.145Z",
    transform: "translate(-41.681 -30.844)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMySubscriptions);
export default __webpack_public_path__ + "static/media/my_subscriptions.32bbe10e0c531b20edbd3ca3be4d8287.svg";
export { ForwardRef as ReactComponent };